<template>
  <slot
    v-if="hasEligibleChats"
    :open="openAddToChatsModal"
  />
</template>

<script setup lang="ts">
import { useDialog, useRenderNotifier } from '@wui/common-library'
import { computed } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { useStoreRooms } from '@/entities/room'


import { useLocalization } from '@/shared/composables/localization'
import type { Contact } from '@/shared/types/api'

import { useEligibleGroupRoomsForContact } from '../lib/use-eligible-group-rooms'

import AddContactToChatsModal from './add-contact-to-chats-modal.vue'

const props = defineProps<{
  pServed: string
}>()

const { showDialog } = useDialog()
const { notifyError } = useRenderNotifier()
const { t } = useLocalization()
const { findByPServed: findContact } = useStoreContacts()
const { findByPServed: findRoom } = useStoreRooms()

const contact = computed<Contact | undefined>(() => {
  const fromContacts = findContact(props.pServed)
  if (fromContacts) {
    return fromContacts
  }

  return findRoom(props.pServed)?.subscribers.values().next().value
})

const { hasEligibleChats } = useEligibleGroupRoomsForContact(contact)

const openAddToChatsModal = () => {
  if (!contact.value) {
    notifyError(t('common.failedToAddSubscriber'))
    return
  }

  showDialog(AddContactToChatsModal, {
    hasOverlay: true,
    isModalMode: true,
    contact: contact.value,
  })
}
</script>
